import React from "react";
import ActivityItem from "./Activityitem";

interface RecentActivityProps {
  activities: any[];
}

const RecentActivity: React.FC<RecentActivityProps> = ({ activities }) => {
  return (
    <div className="recent-activity-card">
      <div className="chart-card-header">
        <h3>🕐 Reportes Recientes</h3>
        <button className="filter-btn">Ver Todo</button>
      </div>

      {activities && activities.length > 0 ? (
        <ul className="activity-list">
          {activities.map((activity) => (
            <ActivityItem key={activity.id} {...activity} />
          ))}
        </ul>
      ) : (
        <div className="empty-state">
          <div className="empty-icon">📭</div>
          <h3>No hay actividad reciente</h3>
          <p>Las nuevas actividades aparecerán aquí</p>
        </div>
      )}
    </div>
  );
};

export default RecentActivity;
